import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles } from 'shared/Buttons/button.styles';
import { buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useHorizontalStepperStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  dialogContent: {
    overflow: 'auto',
    overflowX: 'hidden'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  buttonNext: {
    ...buttonAddStyles
  },
  buttonBack: {
    ...buttonDeleteStyles
  }
}));
